/*
  Size and Weight drawings, full screen on a phone (owner message 21, 2026-10-09). On a screen up to 600 px a tap on a
  drawing ([data-ascot-sketch-zoom], snippets/ascot-size-sketch.liquid) opens it full screen on the page colour, with the
  stacked drawing and its labels at the full width. Two fingers pinch it from 1x to 5x and one finger moves it while it is
  enlarged. A tap, a swipe up or down (at 1x), the close button or Escape closes it; focus goes back to the drawing.
  The drawing is a copy of the one on the page, so the page keeps its own. Runs once however many blocks load it.
*/
(function () {
  if (window.__ascotSketchZoom) return;
  window.__ascotSketchZoom = true;
  var PHONE = '(max-width: 600px)', MAX = 5;

  function open(block) {
    var lastFocus = document.activeElement;
    var box = document.createElement('div');
    box.className = 'ascot-sketch-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Size drawing, full screen. Pinch to zoom; tap or swipe to close.');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ascot-sketch-zoom__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M4 4 L16 16 M16 4 L4 16" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';
    var stage = document.createElement('div');
    stage.className = 'ascot-sketch-zoom__stage';
    var copy = block.cloneNode(true);
    copy.removeAttribute('data-ascot-sketch-zoom');
    copy.removeAttribute('style');
    copy.classList.add('ascot-sketch-zoom__drawing');
    var img = copy.querySelector('img'); if (img) img.removeAttribute('loading');
    stage.appendChild(copy);
    box.appendChild(stage);
    box.appendChild(close);
    document.body.appendChild(box);
    var root = document.documentElement, prevOverflow = root.style.overflow;
    root.style.overflow = 'hidden';

    var scale = 1, tx = 0, ty = 0, pts = {}, start = null, pinch = null, moved = false, swipeY = 0;
    function apply() { stage.style.transform = 'translate(' + tx + 'px,' + (ty + swipeY) + 'px) scale(' + scale + ')'; stage.style.opacity = swipeY ? String(Math.max(0.3, 1 - Math.abs(swipeY) / 400)) : ''; }
    function clampPan() { var r = copy.getBoundingClientRect(), w = r.width / scale, h = r.height / scale; var mx = Math.max(0, (w * scale - innerWidth) / 2 + 24), my = Math.max(0, (h * scale - innerHeight) / 2 + 24); tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty)); }
    function shut() {
      document.removeEventListener('keydown', onKey, true);
      root.style.overflow = prevOverflow;
      box.remove();
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    }
    function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); shut(); } else if (e.key === 'Tab') { e.preventDefault(); close.focus(); } }
    document.addEventListener('keydown', onKey, true);
    close.addEventListener('click', function (e) { e.stopPropagation(); shut(); });
    close.addEventListener('pointerdown', function (e) { e.stopPropagation(); });

    box.addEventListener('pointerdown', function (e) {
      box.setPointerCapture && box.setPointerCapture(e.pointerId);
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 1) { start = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, t: Date.now() }; moved = false; }
      else if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]]; pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: scale }; moved = true; swipeY = 0; }
    });
    box.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length >= 2 && pinch) { var a = pts[ids[0]], b = pts[ids[1]]; scale = Math.max(1, Math.min(MAX, pinch.s * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d)); if (scale === 1) { tx = 0; ty = 0; } clampPan(); apply(); return; }
      if (!start) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
      if (scale > 1) { tx = start.tx + dx; ty = start.ty + dy; clampPan(); apply(); }
      else { swipeY = dy; apply(); }
    });
    function end(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var left = Object.keys(pts).length;
      if (left === 1) { var p = pts[Object.keys(pts)[0]]; start = { x: p.x, y: p.y, tx: tx, ty: ty, t: Date.now() }; pinch = null; return; }
      if (left > 0) return;
      pinch = null;
      if (!moved && start && Date.now() - start.t < 400) { shut(); return; }
      if (scale === 1 && Math.abs(swipeY) > 80) { shut(); return; }
      swipeY = 0; apply(); start = null;
    }
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', end);
    close.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var block = e.target.closest && e.target.closest('[data-ascot-sketch-zoom]');
    if (!block || !window.matchMedia(PHONE).matches) return;
    e.preventDefault();
    open(block);
  });
  // a keyboard or screen reader user gets a real button inside the block (visually hidden), so the drawing keeps its own
  // role="img" and its measurements text
  function mark() {
    var list = document.querySelectorAll('[data-ascot-sketch-zoom]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].querySelector('.ascot-sketch-zoom__open')) continue;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ascot-sketch-zoom__open sr-only'; b.textContent = 'Open the size drawing full screen';
      list[i].appendChild(b);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();
